export type UserCrmSettings = {
  id: string;
  userId: string;
  loginUrl: string;
  accessToken?: string;
  refreshToken?: string;
  crmType: CrmType;
  recipientType: CrmRecipientType;
  crmObjectType: CrmObjectType | SalesforceObjectType;
  autoUpdate: boolean;
  createdat?: number;
  updatedat?: number;
};

export enum CrmType {
  SALESFORCE = "SALESFORCE",
  WEALTHBOX = "WEALTHBOX",
  REDTAIL = "REDTAIL",
  PARAGON_SALESFORCE = "PARAGON_SALESFORCE",
  PARAGON_MICROSOFTDYNAMICS = "PARAGON_MICROSOFTDYNAMICS",
  PARAGON_ZOHO = "PARAGON_ZOHO",
  PARAGON_CLOVEN = "PARAGON_CLOVEN",
  PARAGON_XLR8 = "PARAGON_XLR8",
  PARAGON_PRACTIFI = "PARAGON_PRACTIFI",
  PARAGON_SS_C_BLACKDIAMONDELEMENTS = "PARAGON_SS_C_BLACKDIAMONDELEMENTS",
  PARAGON_FSC = "PARAGON_FSC",
  PARAGON_MAXIMIZER = "PARAGON_MAXIMIZER",
  PARAGON_EQUISOFT = "PARAGON_EQUISOFT",
  LAYLAH = "LAYLAH",
}

export enum CrmRecipientType {
  CONTACT = "CONTACT",
  ACCOUNT = "ACCOUNT",
}

export enum CrmObjectType {
  NOTE = "NOTE",
  EVENT = "EVENT",
}

export enum SalesforceObjectType {
  NOTE = "NOTE",
  EVENT = "EVENT",
  CONTENTNOTE = "CONTENTNOTE",
  INTERACTIONSUMMARY = "INTERACTIONSUMMARY",
  CRITICALNOTE = "CRITICALNOTE",
  CUSTOM = "CUSTOM",
}

export type CrmObject = {
  id: string;
  name: string;
};
